export function normalizeIncomingPath(url: string): string {
  try {
    const parsed = new URL(url)
    const pathname = parsed.pathname
    const params = parsed.searchParams
    const segments = pathname.split('/').filter(Boolean)

    if (['/', '/play/multi', '/play/lobby'].includes(pathname) && params.has('join')) {
      const join = (params.get('join') || '')
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
      return join ? `/play/lobby?join=${encodeURIComponent(join)}` : '/play/lobby'
    }

    if (segments[0] === 'share' && segments[1] === 'game' && segments[2]) {
      const join = (segments[2] || '')
        .trim()
        .toUpperCase()
        .replace(/^#+/, '')
        .replace(/[^A-Z0-9]/g, '')
      return join ? `/play/lobby?join=${encodeURIComponent(join)}` : '/play/lobby'
    }

    if (segments[0] === 'share' && segments[1] === 'poll' && segments[2]) {
      const pollIdMatch = (segments[2] || '').match(/\d+/)
      const pollId = pollIdMatch?.[0] || ''
      return pollId ? `/?p=${encodeURIComponent(pollId)}` : '/'
    }

    if (segments[0] === 'share' && segments[1] === 'list' && segments[2]) {
      const listIdMatch = (segments[2] || '').match(/\d+/)
      const listId = listIdMatch?.[0] || ''
      return listId ? `/lists/${encodeURIComponent(listId)}/play` : '/'
    }

    if (pathname === '/share/game') {
      const join = (params.get('join') || '')
        .trim()
        .toUpperCase()
        .replace(/^#+/, '')
        .replace(/[^A-Z0-9]/g, '')
      return join ? `/play/lobby?join=${encodeURIComponent(join)}` : '/play/lobby'
    }

    if (pathname === '/share/poll') {
      const rawPollId = (params.get('p') || params.get('poll') || '').trim()
      const pollIdMatch = rawPollId.match(/\d+/)
      const pollId = pollIdMatch?.[0] || ''
      return pollId ? `/?p=${encodeURIComponent(pollId)}` : '/'
    }

    if (pathname === '/share') {
      const listId = (params.get('l') || '').trim()
      const score = (params.get('s') || '').trim()
      const result = (params.get('r') || '').trim()
      const nextParams = new URLSearchParams()
      if (listId) nextParams.set('l', listId)
      if (score) nextParams.set('s', score)
      if (result) nextParams.set('r', result)
      const query = nextParams.toString()
      return query ? `/?${query}` : '/'
    }

    return `${pathname}${parsed.search}${parsed.hash}`
  } catch {
    return '/'
  }
}
